import { Box } from '@hopskipdrive/react-components';
import { TimelineConnector } from '@mui/lab';
import styled from 'styled-components';

import { colorTokens } from '../../../../../shared/components/variables';

export const TimelineContainer = styled.div`
  .MuiTimelineSeparator-root {
    margin-right: 9px;
  }
  .MuiTimelineItem-root {
    min-height: 32px;
  }
`;

export const FilledCircle = styled.div<{ $isCompleted?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 6px;
  color: ${colorTokens.text.contrast};
  background-color: ${(props) => (props.$isCompleted ? colorTokens.primary.main : colorTokens.text.disabled)};
  border: 1px solid ${(props) => (props.$isCompleted ? colorTokens.primary.main : colorTokens.text.disabled)};
  border-radius: 50%;
  border-width: 3px;

  svg {
    color: ${colorTokens.text.contrast};
    min-width: 14px;
    min-height: 14px;
  }
`;

export const DashedConnector = styled(TimelineConnector)`
  &.MuiTimelineConnector-root {
    border-left: 3px dashed ${colorTokens.primary.main};
    background-color: transparent;
  }
`;
export const SolidConnector = styled(TimelineConnector)<{ $isCompleted?: boolean }>`
  &.MuiTimelineConnector-root {
    opacity: ${(props) => (props.$isCompleted ? 1.0 : 0.5)};
    margin-left: 1px;
    border-left: 3px solid ${colorTokens.primary.main};
    background-color: transparent;
  }
`;

export const InnerCard = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 12px;
  margin: 10px 0 10px;
  gap: 12px;
  width: 100%;

  border-radius: 12px;
  border: 1.38px solid ${colorTokens.border.main};
  background: #f7fafc;
`;

export const TimestampContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
